module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-civil-ceremony-933da26a1d9d3c8c6686165b302eec9e.png";